import { render, staticRenderFns } from "./aiIcons.vue?vue&type=template&id=48407456&scoped=true&"
import script from "./aiIcons.vue?vue&type=script&lang=js&"
export * from "./aiIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48407456",
  null
  
)

export default component.exports